import React from "react"
import PropTypes from "prop-types"

import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function TourOperatorDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("Tour Operator")}
      endpoint={`/tour-operators/${props.match.params.id}/`}
      successRoute={reverse("tourOperatorList")}
      errorRoute={reverse("tourOperatorDetail", { id: props.match.params.id })}
    />
  )
}

TourOperatorDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
